module.exports = "<div *ngIf=\"message\" [ngClass]=\"{ 'alert': message, 'alert-success': message.type === 'success', 'alert-danger': message.type === 'error' }\"><span  [innerHTML] = \"message.text\"></span>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./resources/assets/typescript/_directives/alert.component.html
// module id = 128
// module chunks = 0